module.exports = __webpack_public_path__ + "media/images/vector-119@2x-c41fdff42c61aa2e2f4b038ed75261e1.png";